import { createValidIcon } from '@ui/icons/utils/type-helper'

export const StarFilledIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M10.6391 2.56574C11.1584 1.44048 12.7247 1.40385 13.3098 2.4591L13.3637 2.56574L15.7778 7.8005L21.5036 8.48018C22.7765 8.63143 23.2828 10.2037 22.345 11.0712L18.111 14.9852L19.236 20.6407C19.485 21.8938 18.1506 22.8689 17.0317 22.2426L12.0008 19.4266L6.97 22.2415C5.85513 22.8655 4.51579 21.8985 4.76571 20.6407L5.88836 14.9852L1.65673 11.0712C0.716985 10.2021 1.22705 8.63089 2.49814 8.48018L8.2239 7.8005L10.6391 2.56574Z'
        fill={color}
      />
    </svg>
  )
})
